<script context="module" lang="ts">
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_brands',
		availableFor: ['pages', 'special-pages'],
		query: gql`
        internal_name
        items {
            section_brands_items_id {
                id
                brand_name
            }
        }
      `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		internal_name: string;
		items: {
			section_brands_items_id: {
				id: string;
				brand_name: string;
			}[];
		};
	};
</script>

<script lang="ts">
	import { Marquee } from 'svelte-fast-marquee';

	export let data: Props; // the component gets all data via this prop (additionally each top-level prop is directly provided to the component)
</script>

<Marquee play={true} pauseOnHover={true} pauseOnClick={true} direction="right">
	<div class="marquee">
		{#each data.items ?? [] as { section_brands_items_id: item }}
			<div class="brand-name">{item.brand_name}</div>
		{/each}
		{#each data.items ?? [] as { section_brands_items_id: item }}
			<div class="brand-name">{item.brand_name}</div>
		{/each}
	</div></Marquee
>

<style lang="scss">
	.marquee {
		display: flex;
		gap: v(content-gap-lg);
	}
	.brand-name {
		@include font(h2);
		&:last-child {
			padding-inline-end: v(content-gap-lg);
		}
	}
</style>
